/**
 * Website Builder Configuration Constants
 */

// History management
export const MAX_HISTORY_ITEMS = 50;
export const AUTO_SAVE_INTERVAL = 30000; // 30 seconds

// Viewport configurations
export const VIEWPORTS = {
  mobile: {
    width: 375,
    height: 667,
    label: 'Mobile',
    icon: '📱',
  },
  tablet: {
    width: 768,
    height: 1024,
    label: 'Tablet',
    icon: '📱',
  },
  desktop: {
    width: 1200,
    height: 800,
    label: 'Desktop',
    icon: '🖥️',
  },
} as const;

export type ViewportType = keyof typeof VIEWPORTS;

// Zoom levels
export const ZOOM_LEVELS = [50, 75, 100, 125, 150, 200] as const;
export const DEFAULT_ZOOM = 100;
export const MIN_ZOOM = 50;
export const MAX_ZOOM = 200;

// Breakpoints for responsive design
export const BREAKPOINTS = {
  mobile: 0,
  tablet: 768,
  desktop: 1024,
  wide: 1440,
} as const;

// Grid configuration
export const GRID_COLUMNS = 12;
export const GRID_GAP = 16;

// Default theme
export const DEFAULT_THEME = {
  fontFamily: 'Poppins, sans-serif',
  primaryColor: '#34C759',
  secondaryColor: '#F5F5F5',
  accentColor: '#FF9500',
  backgroundColor: '#FFFFFF',
  textColor: '#1D1D1F',
  borderRadius: '8px',
  buttonStyle: 'rounded',
  layoutMode: 'modern',
  spacing: {
    small: '8px',
    medium: '16px',
    large: '24px',
    xlarge: '48px',
  },
  typography: {
    h1Size: '32px',
    h2Size: '24px',
    h3Size: '20px',
    bodySize: '16px',
    smallSize: '14px',
    h1Weight: '700',
    h2Weight: '600',
    bodyWeight: '400',
  },
} as const;

// Block constraints
export const MAX_BLOCKS = 50;
export const MIN_BLOCK_HEIGHT = 50;

// Image upload
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

// Image Gallery
export const MAX_GALLERY_IMAGES = 20;
export const DEFAULT_GALLERY_COLUMNS = 4;
export const DEFAULT_GALLERY_GAP = 16;

// Social Feed
export const MAX_SOCIAL_FEEDS = 10;
export const SUPPORTED_SOCIAL_PLATFORMS = [
  'instagram',
  'facebook',
  'twitter',
  'youtube',
  'linkedin',
  'threads',
  'tiktok',
] as const;

export type SocialPlatform = typeof SUPPORTED_SOCIAL_PLATFORMS[number];

// Custom HTML
export const MAX_CUSTOM_HTML_SIZE = 200 * 1024; // 200KB
export const CUSTOM_HTML_PREVIEW_HEIGHT = 600; // pixels

// Debounce delays
export const DEBOUNCE_DELAY = 300;
export const SAVE_DEBOUNCE_DELAY = 1000;

